import React from "react";
import PropTypes from "prop-types";

class SimpleField extends React.Component {

    constructor() {
        super();
        this.input = {};
    }

    focus = () => {
        this.input.focus();
    }

    componentWillReceiveProps(nextProps) {
        const { disabled: previousDisabled } = this.props;
        const { disabled: nextDisabled } = nextProps;

        if(previousDisabled && !nextDisabled) {
            this.focus();
        }
    }

    render() {
        const {
            value = "",
            disabled,
            fieldPlaceholder,
            isReadOnly,

            disabledClassName,
            enabledClassName,
            fieldStyle,

            onFieldChange = () => {},
            handleFieldClick = () => {},
            onEnterPressed = () => {}
        } = this.props;

        const className = disabled? disabledClassName : enabledClassName;

        return (
            <input
                value={value}
                placeholder={fieldPlaceholder}
          
                type='text'
                autoComplete='off'

                className={className}
                disabled={disabled}
                readOnly={isReadOnly}
                style={fieldStyle}
        
                onChange={e => onFieldChange(e.target.value)}
                onClick={handleFieldClick}
                onKeyPress={e => {
                    if(e.key === 'Enter'){
                        onEnterPressed()
                    }
                }}
                ref={c => this.input = c}
        />);
    }
}

SimpleField.propTypes = {
    fieldPlaceHolder: PropTypes.string,
    fieldStyle: PropTypes.object,
    enabledClassName: PropTypes.string,
    disabledClassName: PropTypes.string,
    onFieldChange: PropTypes.func,
    validator: PropTypes.func,
    onClickField: PropTypes.func,
    value: PropTypes.any,
    viewMode: PropTypes.bool,
    maxTextLength: PropTypes.number,
    onBlur: PropTypes.func,
    onEnterPressed: PropTypes.func
};

export default SimpleField;